module.exports = __webpack_public_path__ + "media/images/lb/579-48bde0a6759c445b3633063a941d9f6e.svg";